import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { jsxActions as spoolingGridActions }       from '../../actions/LocationPage/SpoolingView/spoolingGridActions';
import { jsxActions as spoolingViewActions }       from '../../actions/LocationPage/SpoolingView/spoolingViewActions.js';
import { jsxActions as locationPageActions }      from '../../actions/LocationPage/locationPageActions';
import { jsxActions as createSpoolFromCassettesActions }       from '../../actions/Dialogs/CreateSpoolFromCassettesDialog/createSpoolFromCassettesDialogActions.js';
import { jsxActions as fetchEntitiesActions } from '../../actions/FetchEntities/fetchEntitiesActions.js';
import { jsxActions as headerActions }   from '../../actions/Header/headerActions';
import {gridsNames} from '../../enums/gridsNames';
import SpoolingView from '../../components/LocationPage/SpoolingView/spoolingView.js';
import {List} from 'immutable';

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      spoolingGridActions:  bindActionCreators(spoolingGridActions, dispatch),
      spoolingViewActions:    bindActionCreators(spoolingViewActions, dispatch),
      locationPageActions:       bindActionCreators(locationPageActions, dispatch),
      createSpoolFromCassettesActions:       bindActionCreators(createSpoolFromCassettesActions, dispatch),
      fetchEntitiesActions:    bindActionCreators(fetchEntitiesActions, dispatch),
      headerActions: bindActionCreators(headerActions, dispatch),
    }
  }
}

let SpoolingViewContainer = connect(
  (state) => {
    let grid = state.grid.get(gridsNames.LOCATION_SPOOLING) ? state.grid.get(gridsNames.LOCATION_SPOOLING) : null;
    return {
      sSelectedRowsData: grid?.get('selectedRowsData') || List(),
      sCreateSpoolFromCassettesData : state.dialogs.get('createSpoolFromCassettesDialog'),

    };
  },
  mapDispatchToProps
)(SpoolingView);

export default SpoolingViewContainer;




